import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";

export default function PublicLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-brand-paper">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
